import { ajax } from "lib/observable";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { GENERIC_FILTERS } from "constants/action-types";
import { GenericFilters as GenericFiltersSchema } from "schemas/filters";
import siteConfig from "site-config";
import { updateEntities } from "redux-query";
import { normalizeData } from "helpers/data/normalize";
import { List } from "immutable";

export const fetchFilterValuesEpic = (action$, store) =>
    action$.ofType(GENERIC_FILTERS.FETCH.START).switchMap(({ payload, meta }) => {
        const { scope, entities } = store.getState();

        return ajax(siteConfig.api + payload)
            .takeUntil(action$.ofType(GENERIC_FILTERS.RESET))
            .flatMap(({ response, status, xhr }) => {
                const data = normalizeData(response, GenericFiltersSchema, entities.schemas, scope);
                return [
                    updateEntities({
                        genericFilters: (currentValues) => {
                            return {
                                values: List(data.result),
                            };
                        },
                    }),
                    {
                        payload: {
                            results: data.result,
                        },
                        type: GENERIC_FILTERS.FETCH.SUCCESS,
                    },
                ];
            })
            .catch((error) =>
                Observable.merge(
                    Observable.of({
                        error: true,
                        meta,
                        payload: error,
                        type: GENERIC_FILTERS.FETCH.ERROR,
                    })
                )
            );
    });
